module.exports = __webpack_public_path__ + "static/media/research-bg-en.d1007598.jpg";